import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

interface Props {
    children: ReactNode;
}

const ErrorBoundaryWrapper = ({ children }: Props) => {
    const navigate = useNavigate();

    return <ErrorBoundary navigate={navigate}>{children}</ErrorBoundary>;
};

export default ErrorBoundaryWrapper;
